import * as React from 'react';
import { SubmissionState } from '../../interface/SubmissionInterface';
import { numberWithDollarSign } from '../Common/Helpers';
interface DataOverviewProps {
    pre_or_post?: string; 
}

export class DataOverview extends React.Component<SubmissionState & DataOverviewProps, {}> {
    render() {
        var row_count = 0;
        var total_dollars = "";
        var min_date = "";
        var max_date = "";

        if ((this.props.pre_or_post == 'pre' && this.props.FileSummaryOutput_Pre !== undefined)
            || (this.props.pre_or_post == 'post' && this.props.FileSummaryOutput_Post !== undefined)) {
            
            if (this.props.pre_or_post == 'pre' && this.props.FileSummaryOutput_Pre !== undefined) {
                row_count = this.props.FileSummaryOutput_Pre.row_count;
                total_dollars = numberWithDollarSign(this.props.FileSummaryOutput_Pre.total_dollars);
                min_date = new Date(this.props.FileSummaryOutput_Pre.min_date).toLocaleDateString("en-US");
                max_date = new Date(this.props.FileSummaryOutput_Pre.max_date).toLocaleDateString("en-US");
            } else {
                if (this.props.FileSummaryOutput_Post !== undefined) {
                    row_count = this.props.FileSummaryOutput_Post.row_count;
                    total_dollars = numberWithDollarSign(this.props.FileSummaryOutput_Post.total_dollars);
                    min_date = new Date(this.props.FileSummaryOutput_Post.min_date).toLocaleDateString("en-US");
                    max_date = new Date(this.props.FileSummaryOutput_Post.max_date).toLocaleDateString("en-US");
                }
            }

            return <div className="inner-wrap">
                <div className="flex-container">
                    <div className="column">
                        <div className="sum_div"><span className="csv_summary">Row count: </span><span className="result">{row_count}</span></div><div className="sum_div"><span className="csv_summary">Total dollars: </span><span className="result">{total_dollars}</span></div>
                    </div>
                    <div className="column">
                        <div className="sum_div"><span className="csv_summary">Min date: </span><span className="result">{min_date}</span></div><div className="sum_div"><span className="csv_summary">Max date: </span><span className="result">{max_date}</span></div>
                    </div>
                </div>
            </div>

        }
        else {

            return <div className="inner-wrap">
                <div className="flex-container">
                    loading.. <i className="fa fa-spinner"></i>
                </div>
            </div>
        }

    }
}